import React from 'react';
import * as PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import styleConstants from '../../../styleConstants';

const useStyles = makeStyles(theme =>({
	container: {
		paddingBottom: styleConstants.componentSpacing
	},
	largeFigure: {},
	contentContainer: {
		display: 'flex',
		paddingTop: '4rem',
		[theme.breakpoints.down("xs") ]: {
			flexDirection: "column"
		}
	},
	smallFigure: {
		width: '50%',
		[theme.breakpoints.down("xs") ]: {
			width: "100%"
		}
	},
	content: {
		width: '50%',
		padding: '0 2rem',
		[theme.breakpoints.down("xs") ]: {
			width: "100%"
		}
	}
}));

const MultiFigure = props => {
	const classes = useStyles(props);

	return (
		<div className={classes.container}>
			<div className={classes.largeFigure}>{props.largeFigure}</div>
			<div className={classes.contentContainer}>
				<div className={classes.content}>{props.children}</div>
				<div className={classes.smallFigure}>{props.smallFigure}</div>
			</div>
		</div>
	);
};

MultiFigure.propTypes = {
	smallFigure: PropTypes.node.isRequired,
	largeFigure: PropTypes.node.isRequired,
	children: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.arrayOf(PropTypes.node)
	])
};

export default MultiFigure;
